import PersistModel from "./PersistModel";

class Ability extends PersistModel {
  // id: string;
  abilities: Record<string, boolean>;
}

export default Ability;
